export const Colors = {
    Main1: 'rgb(222, 116, 86)', // '#DE7456'
    Main2: 'rgb(43, 50, 64)', // '#2B3240'
    Main3: 'rgb(85, 97, 121)', // GradientFromRGB '#556179'
    Main4: 'rgb(160, 192, 214)', // GradientToRGB '#A0C0D6'
    BackgroundColor: 'rgb(234, 234, 236)', // '#EAEAEC'
}
